import routerOptions0 from "/home/forge/app.eis-s.de/releases/20241106093900/client/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}